import axios from "../http";
import { handleGetRequestParams } from '../common/js/util'

class CarrierReconcliation {
  /* 导出日账单 */
  static postExport(data) {
    let url = `/zwy/api/download/order/day`
    return axios.post(url, data, { responseType: "blob" }).then(res => {
      return Promise.resolve(res);
    });
  }
  /* 导出月账单 */
  static postExportMonthBill(data) {
    let url = `/zwy/api/download/order/mouth`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 删除 */
  static getDelBill(id) {
    let url = `/zwy/api/download/task/delete?id=${id}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 账单列表 */
  static getBillList(data) {
    let url = `/zwy/api/download/task/page?`
    url += handleGetRequestParams(data)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 修改下载次数 */
  static getModDownloadTimes(data) {
    let url = `/zwy/api/download/task/add/times?`
    url += handleGetRequestParams(data)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }

}

export default CarrierReconcliation